import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import { sanitizeConfigOptions } from "@labxchange/util-sanitization";
import className from "../style.module.scss";

export function TextBody(props) {
  return (
    <div
      id={`textBody${props.id}`}
      className={className.textBodyWrapper}
      style={{
        borderColor: props.theme.includes("Dark")
          ? "white"
          : props.theme.includes("Borderless")
            ? "transparent"
            : null,
        backgroundColor: props.theme.includes("Dark") ? "#003E6B" : null,
        color: props.theme.includes("Dark") ? "white" : null,
        boxShadow: props.theme.includes("Borderless") ? "none" : null,
      }}
    >
      <div
        className={`${className.textBody} ${props.textBodyIsSmall ? className.small : ""}`}
        tabIndex={-1}
        style={{
          fontSize: props.textBodyIsSmall
            ? `calc(6/100*${props.textBodyWidth}px)`
            : null,
          textShadow: props.textBodyIsSmall
            ? `0 0 ${(1.75 / 100) * props.textBodyWidth}px rgba(${props.theme.includes("Dark") ? `255,255,255` : `0,0,0`},1)`
            : null,
          padding:
            props.textBodyHeight < 75 || props.textBodyIsSmall ? "16px" : null,
        }}
      >
        <FormattedMessage
          string={props.text}
          sanitizeConfig={sanitizeConfigOptions.BlockText}
          description=""
        />
      </div>
    </div>
  );
}

TextBody.propTypes = {
  id: PropTypes.string.isRequired,
  textBodyIsSmall: PropTypes.bool.isRequired,
  textBodyWidth: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
};
